import { GET_ID } from "./actionTypes";

export const getID = (data) => ({
  type: GET_ID,
  payload: data,
});
